import { EXPRESS_API } from 'configs/api/expressApi';
import { useToastError } from 'lib/hooks';
import { useMutation } from 'react-query';

export const toggleVinSolutionsConnect = async (customerId: number) => {
  const response = await EXPRESS_API.post(
    `/crm/vinsolutions-connect/${customerId}`
  );
  return response.data;
};

export const useToggleVinSolutionsConnectEvent = () => {
  const { showError } = useToastError();
  return useMutation(toggleVinSolutionsConnect, {
    onError: e => {
      showError(e || 'Connect Event could not be turned on for this dealer.');
    },
  });
};
